import { render } from "./Prosperence.vue?vue&type=template&id=75050684&scoped=true"
import script from "./Prosperence.vue?vue&type=script&lang=js"
export * from "./Prosperence.vue?vue&type=script&lang=js"

import "./Prosperence.vue?vue&type=style&index=0&id=75050684&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75050684"]])

export default __exports__